import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0.001, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}>
    {children}
  </motion.div>
);

export const SectionHead = ({ kicker, title, children }) => (
  <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
    <div>
      <p className="font-mono-g mb-4 text-xs uppercase tracking-[0.3em] text-[#D62828]">{kicker}</p>
      <h2 className="font-display text-5xl leading-[0.95] text-[#1C1917] md:text-7xl">{title}</h2>
    </div>
    {children}
  </Reveal>
);
